import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const DoubleChevronLeftIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M12.3536 4.31315C12.1583 4.11789 11.8418 4.11789 11.6466 4.31315L8.31356 7.64616C8.1183 7.84142 8.1183 8.15793 8.31356 8.35319L11.6466 11.6872C11.8418 11.8822 12.1584 11.8822 12.3536 11.6872C12.5488 11.492 12.5487 11.1754 12.3536 10.9801L9.37411 7.99967L12.3536 5.02018C12.5489 4.82492 12.5489 4.50841 12.3536 4.31315Z"
      fill="currentColor"
    />
    <path
      d="M7.68677 4.31315C7.49151 4.11789 7.17501 4.11789 6.97974 4.31315L3.64674 7.64616C3.45147 7.84142 3.45147 8.15793 3.64674 8.35319L6.97974 11.6872C7.17496 11.8822 7.49155 11.8822 7.68677 11.6872C7.88198 11.492 7.88187 11.1754 7.68677 10.9801L4.70728 7.99967L7.68677 5.02018C7.88204 4.82492 7.88204 4.50841 7.68677 4.31315Z"
      fill="currentColor"
    />
  </svg>
);
